import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Default to localStorage
import rootReducer from './reducers'; 

const persistConfig = {
  key: 'root',
  storage,  
  whitelist: ['user','theme','template'],  // the features that i want to persist
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production', 
});

const persistor = persistStore(store);

export { store, persistor };
